import { Injectable, inject } from '@angular/core';
import {DripLessonConfig} from '../models/drip-lesson-config.model';
import { Firestore, collection, collectionData, doc, writeBatch } from '@angular/fire/firestore';
import { first } from 'rxjs';


@Injectable()
export class DripScheduleConfigService {
  private firestore = inject(Firestore);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {
  }

  async getDripScheduleList(tenantId: string, courseId: string): Promise<DripLessonConfig[]> {

    const result = await collectionData(collection(this.firestore, `schools/${tenantId}/courses/${courseId}/dripLessonsConfig`), {idField: 'id'}).pipe(first()).toPromise()

    return result.map((dripConfig) => {
      const data = dripConfig;

      return  {
        id: dripConfig?.id,
        waitPeriod: data?.waitPeriod,
        sendEmail: data?.sendEmail,
        email: {
          subject: data?.email?.subject,
          html: data?.email?.html
        }
      } as DripLessonConfig;
    });

  }

  // update an array of dripLessonConfig to firestore
  async updateDripScheduleList(tenantId: string, courseId: string, dripLessonConfigs: DripLessonConfig[]): Promise<void> {
    const batch = writeBatch(this.firestore);
    dripLessonConfigs.forEach((dripLessonConfig) => {
      const docRef = doc(this.firestore, `schools/${tenantId}/courses/${courseId}/dripLessonsConfig/${dripLessonConfig.id}`);
      batch.set(docRef, dripLessonConfig);
    });
    await batch.commit();
  }
}
